import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class OidcTokenService {
  private oauthService = inject(OAuthService);

  getAccessToken(): string | null {
    return this.oauthService.getAccessToken();
  }

  hasValidToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
